<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="37.373"
    height="19.264"
    viewBox="0 0 37.373 19.264"
  >
    <g transform="translate(-17.22 -388.75)">
      <g transform="translate(27.299 391.345)">
        <path
          class="a"
          :fill="color"
          :stroke="color"
          stroke-width="0.5px"
          d="M445.742,452.534H429.565a.3.3,0,0,1-.293-.252c-.015-.1-.359-2.517,1.2-3.629a5.664,5.664,0,0,1,2.12-.778,4.248,4.248,0,0,0,2.815-1.451c.008-.011.306-.465-.63-1.609-1.5-1.836-1.159-4.74-1.018-5.586a3.987,3.987,0,0,1,7.781,0c.141.846.484,3.75-1.018,5.586-.936,1.143-.638,1.6-.635,1.6a4.251,4.251,0,0,0,2.82,1.458,5.667,5.667,0,0,1,2.12.778c1.563,1.112,1.219,3.527,1.2,3.629A.3.3,0,0,1,445.742,452.534Zm-15.908-.592h15.638a3.263,3.263,0,0,0-.985-2.806,5.151,5.151,0,0,0-1.9-.683,4.84,4.84,0,0,1-3.159-1.673c-.054-.06-.626-.788.644-2.34,1.345-1.644,1.023-4.33.893-5.114a3.4,3.4,0,0,0-6.612,0c-.131.784-.453,3.47.892,5.114,1.27,1.552.7,2.281.629,2.359a4.828,4.828,0,0,1-3.144,1.654,5.15,5.15,0,0,0-1.9.683A3.253,3.253,0,0,0,429.835,451.942Z"
          transform="translate(-429.23 -436.115)"
        />
      </g>
      <path
        class="a"
        :fill="color"
        :stroke="color"
        stroke-width="0.5px"
        d="M802.824,371.39a5.545,5.545,0,0,0-2.075-.762,4.163,4.163,0,0,1-2.761-1.427s-.294-.449.622-1.568c1.471-1.8,1.135-4.641,1-5.469a3.9,3.9,0,0,0-7.617,0c-.138.828-.474,3.671,1,5.469.916,1.119.624,1.564.616,1.575a4.16,4.16,0,0,1-2.756,1.421,5.543,5.543,0,0,0-2.075.762c-.056.04-.109.081-.159.124a2.6,2.6,0,0,0,.446.386l.049-.037a5.046,5.046,0,0,1,1.865-.669,4.727,4.727,0,0,0,3.078-1.62c.068-.077.627-.79-.616-2.309-1.317-1.609-1-4.239-.874-5.007a3.325,3.325,0,0,1,6.474,0c.128.768.443,3.4-.874,5.006-1.243,1.519-.683,2.233-.63,2.291a4.739,4.739,0,0,0,3.093,1.638,5.046,5.046,0,0,1,1.865.669,3.194,3.194,0,0,1,.964,2.747h-9.287a3.9,3.9,0,0,1,.216.58h9.335a.29.29,0,0,0,.287-.247C804.017,374.843,804.354,372.478,802.824,371.39Z"
        transform="translate(-749.731 29.885)"
      />
      <path
        class="a"
        :fill="color"
        :stroke="color"
        stroke-width="0.5px"
        d="M789.831,371.39a5.543,5.543,0,0,1,2.075-.762,4.163,4.163,0,0,0,2.761-1.427s.294-.449-.622-1.568c-1.471-1.8-1.135-4.641-1-5.469a3.9,3.9,0,0,1,7.618,0c.138.828.474,3.671-1,5.469-.916,1.119-.625,1.564-.617,1.575a4.16,4.16,0,0,0,2.756,1.421,5.543,5.543,0,0,1,2.075.762c.056.04.108.081.159.124a2.608,2.608,0,0,1-.446.386l-.049-.037a5.045,5.045,0,0,0-1.865-.669,4.727,4.727,0,0,1-3.078-1.62c-.068-.077-.627-.79.616-2.309,1.317-1.609,1-4.239.874-5.007a3.325,3.325,0,0,0-6.474,0c-.128.768-.443,3.4.874,5.006,1.243,1.519.683,2.233.63,2.291a4.739,4.739,0,0,1-3.093,1.638,5.047,5.047,0,0,0-1.865.669,3.194,3.194,0,0,0-.964,2.747h9.287a3.9,3.9,0,0,0-.216.58H788.94a.29.29,0,0,1-.287-.247C788.638,374.843,788.3,372.478,789.831,371.39Z"
        transform="translate(-771.111 29.885)"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'ThreePeople',
    props: {
      color: {
        type: String,
        default: '#3c3d3e',
      },
    },
  }
</script>

<style scoped>
  svg {
    width: 37.373px;
    height: 19.264px;
  }
</style>
